import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import React, { useState } from 'react';
const DevJSONView = ({ jsonValue, value }) => {
	const isLocal = window.location.hostname === 'localhost';
	const [expanded, setExpanded] = useState(false);

	return isLocal ? (
		<Accordion
			elevation={0}
			disableGutters
			square
			expanded={expanded}
			onChange={() => setExpanded((prev) => !prev)}
			sx={{
				backgroundColor: 'transparent',
				width: '100%',
				'&:not(:last-child)': {
					borderBottom: 0,
				},
				'&::before': {
					display: 'none',
				},
			}}
		>
			<AccordionSummary
				expandIcon={<ExpandMore />}
				sx={{
					borderBottom: 'none',
					padding: 0,
				}}
			></AccordionSummary>
			<AccordionDetails sx={{ padding: '0px' }}>
				{<pre>{JSON.stringify(jsonValue ?? value ?? {}, null, 2)}</pre>}
			</AccordionDetails>
		</Accordion>
	) : (
		<></>
	);
	// return isLocal ? <><pre>{JSON.stringify(jsonValue ?? value ?? {}, null, 2)}</pre></> : <></>;
};
export default DevJSONView;
